// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/AdminOverview.css */

.admin-overview {
    width: 100%;
  }
  
  .charts-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 2rem;
    margin-top: 2rem;
  }
  
  .chart-container {
    background: var(--bg-secondary);
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid var(--border-primary);
  }
  
  .chart-container h3 {
    color: var(--text-primary);
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
  }
  
  @media (max-width: 992px) {
    .charts-grid {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/AdminOverview.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF","sourcesContent":["/* frontend/src/styles/AdminOverview.css */\n\n.admin-overview {\n    width: 100%;\n  }\n  \n  .charts-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 2rem;\n    margin-top: 2rem;\n  }\n  \n  .chart-container {\n    background: var(--bg-secondary);\n    padding: 1.5rem;\n    border-radius: 12px;\n    border: 1px solid var(--border-primary);\n  }\n  \n  .chart-container h3 {\n    color: var(--text-primary);\n    margin-bottom: 1.5rem;\n    font-size: 1.2rem;\n  }\n  \n  @media (max-width: 992px) {\n    .charts-grid {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
